import React, { forwardRef, useState } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import Input from './input'
import styles from './password-input.css'
import eyeOpenIcon from '../../../images/neon/eye-open.svg'
import eyeCloseIcon from '../../../images/neon/eye-close.svg'

/**
 * Password input component with visibility toggle, built on top of Input
 */
const PasswordInput = forwardRef((props, ref) => {
  const [shouldShowPassword, setShouldShowPassword] = useState(false)

  const togglePasswordVisibility = () => {
    setShouldShowPassword(prev => !prev)
  }

  const inputType = shouldShowPassword ? 'text' : 'password'

  return (
    <div className={classnames(styles.fieldWrapper, styles.passwordInputWrapper)}>
      <Input
        {...props}
        ref={ref}
        type={inputType}
      />

      <button
        type="button"
        className={styles.togglePasswordButton}
        onClick={togglePasswordVisibility}
        disabled={props.disabled}
        aria-label={shouldShowPassword ? 'Hide password' : 'Show password'}
        tabIndex={-1}
      >
        <img
          src={shouldShowPassword ? eyeOpenIcon : eyeCloseIcon}
          alt=""
          className={styles.eyeIcon}
        />
      </button>
    </div>
  )
})

PasswordInput.propTypes = {
  label: PropTypes.string.isRequired,
  error: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  disabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  autoComplete: PropTypes.string,
  className: PropTypes.string
}

export default PasswordInput
